module.exports = __webpack_public_path__ + "img/file-loading-icon.2f69edcd.svg";